module.exports = __webpack_public_path__ + "static/img/video.95910fe.png";